import PlanActionTableV2 from '@/routes/plans/plan-detail/PlanActionTableV2/ConversionMainComponents/PlanActionTable.component';

export default PlanActionTableV2;
